var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { MarketSection, MarketTab, RoutePath, generateRoutePath } from '../../app/router/config';
import Filters from '../../components/filters';
import ActivitiesTable from '../../components/market/activities-table';
import Header from '../../components/market/header';
import ItemsGrid from '../../components/market/items-grid';
import MobileToolbar from '../../components/market/mobile-toolbar';
import ProductsGrid from '../../components/market/products-grid';
import Toolbar from '../../components/market/toolbar';
import { useFilters } from '../../hooks/common/use-filters';
import { ItemsOrderBy } from '../../hooks/market/use-items';
import { ProductsOrderBy } from '../../hooks/market/use-products';
import Layout from '../../layout';
import { TokenType } from '../../types/common';
export default function Market() {
    var t = useI18n().t;
    var _a = useParams(), section = _a.section, tab = _a.tab;
    var navigate = useNavigate();
    var filters = useFilters({ tab: tab, section: section });
    if ((!section || !Object.values(MarketSection).includes(section)) &&
        (!tab || !Object.values(MarketTab).includes(tab))) {
        navigate(generateRoutePath(RoutePath.MARKET, { section: MarketSection.CARDS, tab: MarketTab.PRODUCTS }), {
            replace: true,
        });
        return _jsx(_Fragment, {});
    }
    if (!section || !Object.values(MarketSection).includes(section)) {
        navigate(generateRoutePath(RoutePath.MARKET, { section: MarketSection.CARDS, tab: tab }), {
            replace: true,
        });
        return _jsx(_Fragment, {});
    }
    if (!tab || !Object.values(MarketTab).includes(tab)) {
        navigate(generateRoutePath(RoutePath.MARKET, { section: section, tab: MarketTab.PRODUCTS }), {
            replace: true,
        });
        return _jsx(_Fragment, {});
    }
    var sectionsLinks = [
        {
            label: t('market.token-type.cards'),
            path: generateRoutePath(RoutePath.MARKET, { section: MarketSection.CARDS, tab: tab }),
            selected: section === MarketSection.CARDS,
        },
        {
            label: t('market.token-type.mint-passes'),
            path: generateRoutePath(RoutePath.MARKET, { section: MarketSection.MINT_PASSES, tab: tab }),
            selected: section === MarketSection.MINT_PASSES,
        },
        {
            label: t('market.token-type.arise'),
            path: generateRoutePath(RoutePath.MARKET, { section: MarketSection.ARISE, tab: tab }),
            selected: section === MarketSection.ARISE,
        },
        {
            label: t('market.token-type.lands'),
            path: generateRoutePath(RoutePath.MARKET, { section: MarketSection.LANDS, tab: tab }),
            selected: section === MarketSection.LANDS,
            disabled: true,
        },
    ];
    var tabs = [
        {
            label: t('market.tabs.products'),
            path: generateRoutePath(RoutePath.MARKET, { section: section, tab: MarketTab.PRODUCTS }),
            selected: tab === MarketTab.PRODUCTS,
        },
        {
            label: t('market.tabs.items'),
            path: generateRoutePath(RoutePath.MARKET, { section: section, tab: MarketTab.ITEMS }),
            selected: tab === MarketTab.ITEMS,
        },
        {
            label: t('market.tabs.activities'),
            path: generateRoutePath(RoutePath.MARKET, { section: section, tab: MarketTab.ACTIVITIES }),
            selected: tab === MarketTab.ACTIVITIES,
        },
    ];
    function getOrderByOptions() {
        if (tab === MarketTab.PRODUCTS) {
            if (filters.state.tokenTypes[0] !== TokenType.CARD) {
                return [
                    {
                        label: t('order-by.name'),
                        value: ProductsOrderBy.NAME,
                    },
                ];
            }
            return [
                {
                    label: t('order-by.power'),
                    value: ProductsOrderBy.POWER,
                },
                {
                    label: t('order-by.name'),
                    value: ProductsOrderBy.NAME,
                },
            ];
        }
        return [
            {
                label: t('order-by.price'),
                value: ItemsOrderBy.PRICE,
            },
            {
                label: t('order-by.date'),
                value: ItemsOrderBy.DATE,
            },
        ];
    }
    return (_jsx(Layout, { fullWidth: true, children: _jsxs(_Fragment, { children: [_jsx(Header, { sectionsLinks: sectionsLinks }), _jsx(Filters, { filters: filters, fromActivities: tab === MarketTab.ACTIVITIES, fromProducts: tab === MarketTab.PRODUCTS, marketTokenType: section, showCurrencyToken: tab !== MarketTab.PRODUCTS }), _jsx(Toolbar, { direction: filters.state.direction, orderBy: filters.state.orderBy, orderByOptions: getOrderByOptions(), searchQuery: filters.state.searchQuery, setDirection: filters.actions.setDirection, setOrderBy: filters.actions.setOrderBy, tabs: tabs }), _jsx(MobileToolbar, { direction: filters.state.direction, orderBy: filters.state.orderBy, orderByOptions: getOrderByOptions(), searchQuery: filters.state.searchQuery, setDirection: filters.actions.setDirection, setOrderBy: filters.actions.setOrderBy }), _jsxs(Container, { children: [tab === MarketTab.PRODUCTS && (_jsx(ProductsGrid, { filters: filters, section: section, tokenType: filters.state.tokenTypes[0] })), tab === MarketTab.ITEMS && (_jsx(ItemsGrid, { filters: filters, section: section, tokenType: filters.state.tokenTypes[0] })), tab === MarketTab.ACTIVITIES && (_jsx(ActivitiesTable, { filters: filters, tokenType: filters.state.tokenTypes[0] }))] })] }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: auto;\n  width: 100%;\n\n  & > div {\n    flex-shrink: 0;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: auto;\n  width: 100%;\n\n  & > div {\n    flex-shrink: 0;\n  }\n"])));
var templateObject_1;
